import { UserCompanyInfo } from "./../../../../models/domains/pbm/user/user-company-info";
import { AbstractParser } from "../../parser";
import { User } from "src/app/ui/models/domains/pbm/user/user";
import { UserRole } from "src/app/ui/models/domains/pbm/user/user-role";
import { UserPermission } from "src/app/ui/models/domains/pbm/user/user-permission";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { CompanyParser } from "../company/company.parser";

export class SearchUserByUserKeyParser extends AbstractParser<User> {
  parse(payload: any): User {
    const user = new User();
    user.setUserKey(payload.UserKey.Value);
    user.setActivate(payload.Active);
    user.setName(payload.Name);
    user.setEmail(payload.Email);
    user.correlatedId = payload.CorrelatedId;
    user.setUserCompanyInfo(this.parseUserCompanyInfo(payload.CompanyInfo));
    user.setAllowedCompanies(this.parseAllowedCompanies(payload.AllowedCompanies));
    user.setUserRoleList(this.parseUserRoleList(payload.UserRoles));
    return user;
  }

  private parseUserCompanyInfo(payload: any): UserCompanyInfo {
    const userCompanyInfo = new UserCompanyInfo();
    userCompanyInfo.setTelephone(payload ? payload.Telephone : "");
    userCompanyInfo.setFiscalNumber(payload ? payload.FiscalNumber : "");
    userCompanyInfo.setCorporateName(payload ? payload.CorporateName : "");
    userCompanyInfo.setHealthProfessional(payload ? payload.HealthProfessional : "");
    userCompanyInfo.setClassCouncil(payload ? payload.ClassCouncil : "");
    userCompanyInfo.setRegistrationNumber(payload ? payload.RegistrationNumber : "");
    return userCompanyInfo;
  }

  private parseAllowedCompanies(payload: Array<any>): Array<Company> {
    let data: Array<Company> = new Array<Company>();
    const companyParser = new CompanyParser();
    if (Array.isArray(payload)) {
      payload.forEach((p) => {
        data.push(companyParser.parse(p));
      });
    }
    return data;
  }

  private parseUserRoleList(payload: any): UserRole[] {
    const userRoleList: UserRole[] = payload.map((i) => {
      const userRole = new UserRole();
      userRole.setUserRoleKey(i.UserRoleKey.Value);
      userRole.setName(i.Name);
      userRole.setUserPermissionList(this.parseUserPermissionList(i.UserPermissions));
      return userRole;
    });
    return userRoleList;
  }

  private parseUserPermissionList(payload: any): UserPermission[] {
    const userPermissionList: UserPermission[] = payload.map((i) => {
      const userPermission = new UserPermission();
      userPermission.setUserPermissionKey(i.UserPermissionKey.Value);
      userPermission.setName(i.Name);
      userPermission.setCode(i.Code);
      return userPermission;
    });
    return userPermissionList;
  }
}
